'use strict';
var DateSelectorModel = require('../models/date_selector.model');

module.exports = Odigeo.View.extend({

    initialize: function(options) {
        this.parent = options.parent;
        this.model = new DateSelectorModel();
        this.tabIndex = options.tabIndex;
        this.template = options.template || Odigeo._.template(
            this.parent.$el.find('#date_selector_template').html(),
            Odigeo.Utils.getTmplSettings({variable: null})
        );
        this.render();
        this.$datepicker = this.$el.find('.date_selector_input');
        var datepickerOptions = {
            format: options.format,
            index: options.index,
            closeDelay: 0,
            permissible: true,
            placeholder: options.placeholder,
            closeButton: options.closeButton,
            skipHide: true,
            type: options.type,
            isCssVariationHeaderDesktop: options.isCssVariationHeaderDesktop,
            errorMessages: Odigeo.AB.isCssVariationHeaderDesktop ? options.errorMessages : null,
        };
        if (options.datepickerClasses) {
            datepickerOptions = Odigeo._.extend(datepickerOptions, options.datepickerClasses);
        }

        Odigeo.UIElements.enhanceDatepicker(this.$datepicker, datepickerOptions);
        this.setCallbacks(options.callbacks);
        this.setListeners();
        this.updateCalendarDates();
    },

    setListeners: function() {
        this.$datepicker.on(Odigeo.Events.change, Odigeo._.bind(this.onChangeDateSelector, this));
        this.$datepicker.on(Odigeo.Events.blur, Odigeo._.bind(this.checkErrors, this));
        this.$datepicker.closest('.datepicker').on(Odigeo.Events.tap, Odigeo._.bind(this.onClickDateSelector, this));
        this.listenTo(this.model, 'change:selectedDate', this.updateSearchSegments);
        this.listenTo(this.model, 'change:selectedDate', this.setInputValue);
        Odigeo.on('DateSelectorView:updateDates', Odigeo._.bind(this.updateCalendarDates, this));
    },

    onClickDateSelector: function() {
        if (!Odigeo._.isUndefined(this.onFocusCb)) {
            this.onFocusCb(this);
        }
    },

    onChangeDateSelector: function(event, data) {
        this.model.set('selectedDate', data.selectedDate);
    },

    checkErrors: function() {
        if (Odigeo._.isNull(this.model.get('selectedDate'))) {
            this.triggerError();
        }
    },

    setCallbacks: function(callbacks) {
        this.onFocusCb = callbacks.onFocus;
    },

    setInputValue: function() {
        var selectedDate = this.model.get('selectedDate');
        this.$datepicker.trigger('config', {value: selectedDate});
        Odigeo.trigger('DateSelectorView:updateDates');
        if (selectedDate) {
            this.trigger('fulfilled');
        }
    },

    updateCalendarDates: function() {
        var dates = this.parent.model.getDates();
        this.$datepicker.trigger('config', {dates: dates});
    },

    updateCalendarType: function() {
        var type = this.parent.model.getOriginalData().type;
        var map = {
            'oneWayTrip': 'single',
            'roundTrip': 'dual',
            'multiTrip': 'multiple',
        };
        var config = {
            type: map[type],
            permissible: !this.parent.model.isOneWay(),
        };
        this.$datepicker.trigger('config', config);
        this.updateCalendarDates();
    },

    updateSearchSegments: function() {
        this.parent.model.trigger('update');
    },

    open: function() {
        this.$datepicker.trigger('open');
    },

    toggle: function(display) {
        this.$el.toggleClass('odf-hidden', !display);
    },

    triggerError: function() {
        this.$datepicker.trigger('error', 'invalid');
    },

    removeError: function() {
        this.$datepicker.trigger('clearError');
    },

    render: function() {
        this.$el.html(this.template({tabIndex: this.tabIndex}));
        return this;
    },

    isEmptyOrHasError: function() {
        return !this.model.get('selectedDate') || !!this.$datepicker.data('error');
    },

    setFocus: function() {
        this.open();
    },
});
